import React from 'react'
import { ImSwitch } from 'react-icons/im'
import { logoutFunction } from '../../../_helpers'
import Button from '../buttons/button'
import TransParentButton from '../TransparentButton.js/TransParentButton'

function Logout ({ isOpen, closeModal }) {
  if (!isOpen) return null

  const handelLogout = () => {
    logoutFunction()
  }

  return (
    <div className='fixed z-50 inset-0 flex items-center justify-center bg-black bg-opacity-70'>
      <div className='bg-[#fff] p-8 rounded-[19px] shadow-lg text-center md:w-[500px] w-11/12 mx-auto'>
        <div className='flex items-center justify-center mb-4'>
          <img src='/cross.png' alt='' />
        </div>
        <h2 className='text-[17px] font-[600] text-black mb-4'>
          Are you sure you want to logout?
        </h2>
        <p className='text-[#000]/80 text-sm font-[500]'>
          You are about to end your session. Any unsaved changes will be lost.
        </p>
        <div className='py-6 flex justify-center gap-4 items-center'>
          <TransParentButton
            type='submit'
            onClick={closeModal}
            className='mx-auto'
          >
            {' '}
            Cancel
          </TransParentButton>
          <Button
            type='submit'
            className='mx-auto flex items-center gap-2'
            onClick={handelLogout}
          >
            <span>
              <ImSwitch size={20} />
            </span>{' '}
            Logout
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Logout
